import { Theme } from '@mui/material/styles';

export const dialogStyles = {
    '& .MuiPaper-root': {
        maxWidth: 800,
    },
};

export const contentStyles = {
    paddingTop: 2,
    paddingBottom: 8,
};

export const avatarStyles = (theme: Theme) => ({
    width: 300,
    height: 300,
    margin: 'auto',
    backgroundColor: theme.palette.secondary.light,
});

export const avatarIconStyles = (theme: Theme) => ({
    fontSize: 32,
    color: theme.palette.divider,
});

export const actionsStyles = (theme: Theme) => ({
    justifyContent: 'space-between',
    padding: theme.spacing(2, 4),
    borderTop: `1px solid ${theme.palette.divider}`,

    '&>*': {
        padding: 0,
        textTransform: 'capitalize',
        fontSize: '1rem',
        letterSpacing: '0.05em',
        flexDirection: 'column',
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '& .MuiButton-startIcon': {
            marginRight: 0,
            marginBottom: 1,
        },
    },
});
